/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMCartViewPayload } from '@/data/types/GTM';
import { extractPartNumberFather } from '@/data/utils/extractPartNumberFather';
import { findProductAttribute } from 'integration/utils/findProductAttribute';

export const getGTMCartViewEventData = async (payload: GTMCartViewPayload) => {
	const { cart: _cart, storeName, orgName, orgId, orderItemListRows = [] } = payload;
	const { grandTotal = 0, grandTotalCurrency = '' } = _cart;
	const hcl_account = orgId ? orgName : null;
	const cart = { grandTotal, grandTotalCurrency };

	const products = orderItemListRows.map((row) => {
		const attributes = row.details.attributes;
		return {
			item_id: row.details?.partNumber || row.parentProduct?.partNumber,
			item_group_id: extractPartNumberFather(
				row.details?.partNumber || row.parentProduct?.partNumber || ''
			),
			item_name: row.product.name,
			coupon: 'N/A',
			discount:
				(row.product.productPrice?.list ?? 0) > (row.product.productPrice?.offer ?? 0)
					? (row.product.productPrice?.list ?? 0) - (row.product.productPrice?.offer ?? 0)
					: 0,
			affiliation: 'Dportenis',
			item_brand: findProductAttribute(attributes, 'Marca')?.value,
			item_category: findProductAttribute(attributes, 'Genero')?.value,
			item_category1: findProductAttribute(attributes, 'Familia')?.value,
			item_category2: findProductAttribute(attributes, 'Uso')?.value,
			item_variant: findProductAttribute(attributes, 'Talla')?.value,
			price: Number(row.orderItemListRow.price.orderItemPrice),
			currency: 'MXN',
			quantity: 1,
		};
	});

	return {
		cart,
		products,
		hcl_account,
		marketplaceStore: storeName,
	};
};
